<template>
  <a-modal :forceRender="true" :visible="value" :title="title" :maskClosable="true" :closable="closable" :destroyOnClose="true" @cancel="handleCancel" @ok="handleOk" :width="width" :keyboard="true">
    <div class="search-all-box add-modal">
      <a-form ref="addForm" :form="stadiumForm" :label-col="labelCol" :wrapper-col="wrapperCol" style="width: 100%">
        <a-form-item label="场馆名称：">
          <a-input class="search-input" v-decorator="rules.name" placeholder="请输入场馆名称"></a-input>
        </a-form-item>
        <a-form-item label="场馆类型：">
          <a-checkbox-group v-decorator="rules.category_id" :options="stadiumType" @change="stadiumTypeChange" />
        </a-form-item>
        <a-form-item label="场馆地址：">
          <a-input class="search-input" @blur.native="mapInputChange" v-decorator="rules.address" placeholder="请输入场馆地址"></a-input>
        </a-form-item>
        <a-form-item label="地址坐标：">
          <a-input class="search-input" :disabled="true" v-decorator="rules.lng_lat" placeholder="请从地图选择精确地址，叫自动获取经纬度，用于精准定位场馆、导航等"></a-input>
        </a-form-item>
        <div class="map-content">
          <div class="map-sreach">
            <a-select show-search @focus="mapFocus" :value="mapValue" placeholder="搜索地点" style="width: 200px" :default-active-first-option="false" :show-arrow="false" :filter-option="false" :not-found-content="null" @search="mapSearch"
              @change="mapChange">
              <a-select-option v-for="d in mapValueList" :value="d.id" :key="d.id">
                {{ d.text }}
              </a-select-option>
            </a-select>
          </div>
          <div class="map" id="map"></div>
        </div>

        <a-form-item label="开放时间：">
          <a-input class="search-input" v-decorator="rules.open_time" placeholder="请输入放时间"></a-input>
        </a-form-item>
        <a-form-item label="联系电话：">
          <a-input class="search-input" v-decorator="rules.mobile" placeholder="请输入联系电话"></a-input>
        </a-form-item>
        <a-form-item label="VR链接：">
          <div class="vr-content">
            <a-input class="search-input" v-decorator="rules.vr_url" placeholder="请输入VR链接"></a-input>
            <div @click="toVRLink" :href="vrLInk" class="vr-link"> 打开 </div>
          </div>

        </a-form-item>
        <a-form-item label="场馆封面图：">
          <div class="img-content" v-decorator="rules.cover">
            <div class="img-cover" :class="{empty: !imgUrl}" :style="`background-image: url('${imgUrl}')`"></div>
            <div class="upload-btn" @click="$refs.uploadImg.click()">上传</div>
            <input name="img" ref="uploadImg" @change="uploadImg" type="file" style="display: none;">
          </div>
        </a-form-item>
        <a-form-item label="场馆简介：" :labelCol="{ span: 4}" :wrapperCol="{ span: 24 }">
          <div v-decorator="rules.intro">
            <qEditor :imgLabel="'venue_intro'" :valuetxt="editorCon" @inputChange="changeContent"></qEditor>
          </div>
        </a-form-item>
      </a-form>
    </div>
    <!-- 上传进度 -->
    <a-spin :tip="`上传中 ${fileData.progress}% ...`" :spinning="uploadImgStatus == 'uploading'&& quillUpdateImg">
      <a-icon slot="indicator" type="loading" style="font-size: 24px" spin />
    </a-spin>
    <loading v-if="loading"></loading>
  </a-modal>

</template>

<script>
import qEditor from '../QuillEditor.vue'
import services from '../../assets/js/services';
import loading from '../../components/loading.vue';

import axios from "axios";
import { v4 as uuidv4 } from 'uuid';
import { mapActions } from "vuex";
export default {
  props: {
    value: Boolean,
    title: {
      type: String,
      default: '添加场馆'
    },
    closable: {
      type: Boolean,
      default: true
    },
    showCancel: {
      type: Boolean,
      default: true
    },
    cancelText: {
      type: String,
      default: '取 消'
    },
    showConfirm: {
      type: Boolean,
      default: true
    },
    confirmText: {
      type: String,
      default: '确 定'
    },
    confirmLoading: {
      type: Boolean,
      default: false
    },
    width: {
      type: [String, Number],
      default: null
    },
    stadiumId: {
      type: [String, Number],
      default: null
    },
  },
  components: {
    qEditor,
    loading
  },
  data() {
    let that = this
    return {
      loading: false,
      labelCol: {
        xs: { span: 4 },
        sm: { span: 4 },
      },
      wrapperCol: {
        xs: { span: 20 },
        sm: { span: 20 },
      },
      stadiumForm: this.$form.createForm(this, { name: 'addStadium' }),
      addForm: {
        name: "",
        category_id: "",
        address: "",
        lng_lat: "",
        open_time: "",
        mobile: "",
        vr_url: "",
        intro: "",
        cover: "",
      },
      rules: {
        name: [
          'name',
          {
            rules: [

              {
                required: true,
                message: '请输入场馆名称!',
              },
            ],
          },
        ],
        category_id: [
          'category_id',
          {
            rules: [
              {
                required: true,
                message: '请选择场馆类型!',
              },

            ],
          },
        ],
        address: [
          'address',
          {
            rules: [
              {
                required: true,
                message: '请输入场馆地址!',
              },
            ],
          },
        ],
        lng_lat: [
          'lng_lat',
          {
            rules: [
              {
                required: true,
                message: '请输入场馆坐标!',
              },

            ],
          },
        ],
        open_time: [
          'open_time',
          {
            rules: [
              {
                required: false,
                message: '请输入开放时间!',
              },

            ],
          },
        ],
        mobile: [
          'mobile',
          {
            rules: [
              {
                required: false,
                message: '请输入联系电话!',
              },

            ],
          },
        ],
        vr_url: [
          'vr_url',
          {
            rules: [
              {
                required: false,
                message: '请输入VR链接!',
              },

            ],
          },
        ],
        intro: [
          'intro',
          {
            initialValue: that.article_content,
            rules: [
              {
                required: true,
                message: '请输入场馆简介!',
              },

            ],
          },
        ],
        cover: [
          'cover',
          {
            rules: [
              {
                required: true,
                message: '请上传封面图!',
                validator: (rule, value, callback) => {
                  // const { getFieldValue } = this.props.form
                  console.log(rule, value,this.imgUrl);
                  if(!value && this.imgUrl == "" ) {
                    callback('请上传封面图')
                  }else if (this.imgUrl)  {
                    this.stadiumForm.setFieldsValue({ cover: `${this.imgUrl}` })
                  }
                  callback()
                }
              },

            ],
            trigger: "change"
          },
        ],
      },
      editorCon: '', // 编辑器内容
      stadiumType: [],
      map: null,
      markerLayer: null,
      suggest: null,
      mapValue: "",
      mapValueList: [],
      uploadImgStatus: "",
      quillUpdateImg: false,
      imgUrl: "",
      limitSize: 1024 * 1024 * 10, // 10MB
      fileData: {
        progress: 0
      }, // 上传图片数据
      vrLInk: '',
    }
  },
  computed: {
    myValue() {
      return this.value;
    }
  },
  watch: {
    myValue: {
      handler(newVal) {
        if (newVal) {
          this.editorCon = ""
          this.imgUrl = ""
          this.vrLInk = ''
          this.mapValue = ""
          this.mapValueList = ""
          this.$nextTick(() => {
            this.initMap()
          });
        }
      }
    },
    stadiumId: {
      handler(newVal) {
        console.log(newVal);

        // 可以在这里处理 title 变化时的逻辑
        if (newVal) {
          this.getStadiumInfo(newVal)
          // this.stadiumForm.resetFields()
        }
      }
    }
  },
  mounted() {
    this.setStadiumType()
    // this.stadiumType = [
    //   { label: '学生扫码加入', value: 1 },
    //   { label: '教师添加', value: 2 },
    // ]
  },
  methods: {
    ...mapActions(["getStadiumAddress", "addStadiumAddress", "editStadiumAddress", "getStadiumAddressInfo", "getStadiumType"]),
    stadiumTypeChange(e) {
      this.stadiumForm.setFieldsValue({ category_id: e })
    },
    handleCancel() {
      this.$emit('input', false); // 触发 v-model 更新
      this.$emit('cancel');
    },
    uploadImg() {
      let file = this.$refs.uploadImg.files[0];
      if (file) {
        this.handleUpload(file)
      } else {
        return
      }
    },
    setStadiumType() {
      this.getStadiumType({
        page: 1,
        size: 100,
      }).then((res) => {
        if (res.code == "0000" && res.data) {
          this.stadiumType = res.data.items.map(item => {
            return {
              label: item.name,
              value: item.id,
            }
          })
        }
      });
    },
    getStadiumInfo(id) {
      this.getStadiumAddressInfo({ id: id }).then(res => {
        if (res.code == "0000" && res.data) {
          let data = res.data
          this.stadiumForm.setFieldsValue({
            name: data.name,
            category_id: data.category_id ? data.category_id.split(',').map(item => Number(item)) : [],
            address: data.address,
            lng_lat: data.lng_lat,
            open_time: data.open_time,
            mobile: data.mobile,
            vr_url: data.vr_url,
            intro: data.intro,
            cover: data.cover,
          })
          this.editorCon = data.intro
          this.imgUrl = data.cover
          this.vrLInk = data.vr_url
          // 设置地图位置
          if (data.lng_lat) {
            let coords = data.lng_lat.split(',')
            let location = new window.TMap.LatLng(parseFloat(coords[1]), parseFloat(coords[0]))
            this.markerLayer.setGeometries([]);
            this.mapValue = data.address;
            this.markerLayer.updateGeometries([
              {
                id: '0', // 点标注数据数组
                position: location,
              },
            ]);
            this.map.setCenter(location);
          }
        }
      })
    },
    handleOk() {
      //   this.$emit('confirm')
      this.stadiumForm.validateFields(async err => {

        if (!err) {
          let params = this.stadiumForm.getFieldsValue()
          for (let key in params) {
            if (params[key] == undefined) {
              params[key] = ''
            }
          }

          const formData = new FormData();
          formData.append("address", params.address);
          formData.append("category_id", params.category_id ? params.category_id.join(',') : '');
          formData.append("cover", params.cover);
          // intro 为富文本字符串，请求前对其中的 HTML 标签进行转义
          if (params.intro && typeof params.intro === 'string') {
            params.intro = params.intro.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
          }
          formData.append("intro", params.intro);
          formData.append("lng_lat", params.lng_lat);
          formData.append("mobile", params.mobile);
          formData.append("name", params.name);
          formData.append("open_time", params.open_time);
          formData.append("vr_url", params.vr_url);
          this.loading = true
          if (this.stadiumId) {
            formData.append("_method", "put");
            let result = await services.editStadiumAddress({ id: this.stadiumId, data: formData })
            if (result.code == "0000") {
              this.$message.success("编辑成功")
              this.handleCancel()
              this.$emit('confirm')
              this.editorCon = ""
              this.imgUrl = ""
            } else {
              this.$message.error(result.message)
            }
          } else {
            let result = await services.addStadiumAddress(formData)
            if (result.code == "0000") {
              this.$message.success("添加成功")
              this.handleCancel()
              this.$emit('confirm')
              this.editorCon = ""
              this.imgUrl = ""
            } else {
              this.$message.error(result.message)
            }
          }
          this.loading = false

        }
      });

    },
    mapSearch(val) {
      this.suggest.getSuggestions({ keyword: val, location: this.map.getCenter() }).then((res) => {
        this.mapValueList = res.data.map(item => {
          return {
            text: item.address,
            location: item.location,
            id: item.id,
          }
        })
      })
    },
    mapFocus() {

      let lat = ''
      if (this.stadiumForm.getFieldsValue(["address"]).address && this.mapValue == "") {
        lat = this.stadiumForm.getFieldsValue(["address"]).address
        this.mapValue = lat
        this.suggest.getSuggestions({ keyword: lat, location: this.map.getCenter() }).then((res) => {
          this.mapValueList = res.data.map(item => {
            return {
              text: item.address,
              location: item.location,
              id: item.id,
            }
          })
          if (this.mapValueList.length > 0) {
            this.mapChange(this.mapValueList[0].id)
          }
        })
      }

    },
    mapInputChange() {
      let lat = ''
      if (this.stadiumForm.getFieldsValue(["address"]).address) {
        lat = this.stadiumForm.getFieldsValue(["address"]).address
        this.mapValue = lat
        this.suggest.getSuggestions({ keyword: lat, location: this.map.getCenter() }).then((res) => {
          this.mapValueList = res.data.map(item => {
            return {
              text: item.address,
              location: item.location,
              id: item.id,
            }
          })
          if (this.mapValueList.length > 0) {
            this.mapChange(this.mapValueList[0].id)
          }
        })
      }
    },
    mapChange(val) {
      let location = this.mapValueList.find(item => item.id == val).location
      this.mapValue = this.mapValueList.find(item => item.id == val).text
      this.markerLayer.setGeometries([]);
      this.markerLayer.updateGeometries([
        {
          id: '0', // 点标注数据数组
          position: location,
        },
      ]);
      this.map.setCenter(location);
      this.stadiumForm.setFieldsValue({ lng_lat: `${location.lng},${location.lat}` })
    },
    initMap() {
      this.map = new window.TMap.Map(document.getElementById("map"), {
        center: new window.TMap.LatLng(39.954190, 116.360717),//设置地图中心点坐标
        zoom: 17,   //设置地图缩放级别
        pitch: 43.5,  //设置俯仰角
        rotation: 45,   //设置地图旋转角度
        viewMode: '2D',
        showControl: false,
      });
      //创建marker
      this.markerLayer = new window.TMap.MultiMarker({
        map: this.map,
        geometries: [],
      });

      this.suggest = new window.TMap.service.Suggestion({
        pageSize: 20, // 返回结果每页条目数
      });
      this.map.on("click", (evt) => {
        this.markerLayer.setGeometries([])
        this.markerLayer.add({
          id: "marker",
          position: evt.latLng,
        });
        let lat = evt.latLng.getLat().toFixed(6);
        let lng = evt.latLng.getLng().toFixed(6);
        this.stadiumForm.setFieldsValue({ lng_lat: `${lng},${lat}` })
      })

    },
    changeContent(con) {
      this.stadiumForm.setFieldsValue({ intro: con })
    },
    handleUpload(file) {
      let that = this
      if (file.size > that.limitSize) return that.$message.info(`请上传不超过${that.limitText}的文件`)
      that.uploadImgStatus = 'uploading'
      that.quillUpdateImg = true
      that.fileData = {
        filename: file.name, // 附件名称
        progress: 0, // 上传进度
        view_url: URL.createObjectURL(file),
        path: ''
      }

      const chunkSize = 1024 * 1024 * 3; // 3MB
      const totalChunks = Math.ceil(file.size / chunkSize); // 计算文件总片数
      const uuid = uuidv4() // 文件唯一标识
      let currentChunk = 0; // 当前上传的分片索引
      let uploadedBytes = 0; // 已上传的总字节数

      function uploadChunk() {
        const start = currentChunk * chunkSize;
        const end = Math.min(start + chunkSize, file.size);
        const data = file.slice(start, end);
        const formData = new FormData();
        formData.append("file", data, file.name);
        formData.append("label", "venue_cover");
        formData.append("is_tmp", "1");
        formData.append("uuid", uuid);
        formData.append("chunks", totalChunks);
        formData.append("chunk", currentChunk);
        // 发送分片数据
        axios.post(`${services.HOST}/api/upload/file`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          onUploadProgress: (progressEvent) => {
            const chunkUploadedBytes = progressEvent.loaded;
            uploadedBytes = currentChunk * chunkSize + chunkUploadedBytes;
            // 更新上传进度
            let percent = Math.round((uploadedBytes / file.size) * 100);
            if (percent > that.fileData.progress) {
              that.fileData.progress = percent > 100 ? 100 : percent;
            }
          }
        }).then(({ data: result }) => {
          if (currentChunk < totalChunks - 1) {
            // 继续上传下一片
            currentChunk++;
            uploadChunk();
          } else {
            that.quillUpdateImg = false
            if (result.code == "0000") {
              that.uploadImgStatus = 'success'
              that.$set(that.fileData, 'progress', 100)
              that.$set(that.fileData, 'view_url', result.data.url)
              that.$set(that.fileData, 'path', result.data.path)
              that.imgUrl = result.data.url
              that.stadiumForm.setFieldsValue({ cover: `${that.imgUrl}` })
            } else {
              that.$message.error("图片插入失败")
              that.fileData = null
              that.uploadImgStatus = 'error'
            }

          }
        }).catch((error) => {
          that.quillUpdateImg = false
          that.uploadImgStatus = 'error'
          console.error("上传失败", error);
        });
      }

      // 开始上传第一片
      uploadChunk();
    },
    toVRLink() {
      if (this.stadiumForm.getFieldValue("vr_url")) {
        window.open(this.stadiumForm.getFieldValue("vr_url"), '_blank');
      } else {
        this.$message.info('VR链接为空');
      }
    }
  }
}
</script>

<style lang="less" scoped>
.search-all-box.add-modal {
  width: 600px;
  .map-content {
    position: relative;
    margin-bottom: 20px;
    .map {
      width: 100%;
      height: 300px;
    }
    .map-sreach {
      position: absolute;
      top: 10px;
      left: 20px;
      z-index: 1001;
    }
  }
  .vr-content {
    display: flex;
    align-items: center;
    .vr-link {
      display: inline-block;
      color: #1890ff;
      cursor: pointer;
      white-space: nowrap;
      margin-left: 10px;
    }
  }

  .img-content {
    display: flex;
    .img-cover {
      width: 160px;
      height: 90px;
      border: 1px solid #d9d9d9;
      background-size: cover;
      background-position: center;
      &.empty {
        background-color: #f5f5f5;
        &::before {
          content: "请上传封面图";
          display: block;
          width: 100%;
          height: 100%;
          line-height: 90px;
          text-align: center;
          font-size: 14px;
          color: #999;
        }
      }
    }
    .upload-btn {
      width: 80px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      background: #1890ff;
      color: #fff;
      border-radius: 4px;
      margin-left: 20px;
      cursor: pointer;
      position: relative;
      &::before {
        content: "请上传的640px：360px，.png,.jpg,.jpeg 图片，图片大小小于5M";
        color: rgb(255, 187, 39);
        position: absolute;
        top: 35px;
        left: 0;
        width: 300px;
      }
    }
  }
  /deep/.ant-form-explain {
    // line-height: 1.2;
    margin-top: 5px;
  }
}
</style>